module.exports = __webpack_public_path__ + "static/media/7599C67B-4382-4716-A382-817F89577FD3.715e8dbf.bin";